import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faHeart } from '@fortawesome/free-regular-svg-icons';
import { faBook, faSeedling, faHeart as faHeartSolid } from '@fortawesome/free-solid-svg-icons';
import 'main.css'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);


library.add(faUser, faSeedling, faBook, faHeart, faHeartSolid)